exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.circleHowItWorks[data-v-7a0072cd]{padding:8px;text-align:center;width:90px;height:90px;border-radius:50%;border:2px solid #87983F;border-top-color:#87983f;border-right-color:#87983f;border-bottom-color:#87983f;border-left-color:#87983f;cursor:pointer;font-size:32pt;padding:12px;margin-top:auto;margin-bottom:auto;margin-left:auto;margin-right:auto\n}\n.quote[data-v-7a0072cd]{content:\"\\201C\";font-family:Georgia, serif;font-size:60px;font-weight:bold\n}\n", ""]);

// exports
